// import React from 'react';
// import CircularProgress from '@material-ui/core/CircularProgress';
// import useStyles from '../../styles/loadingIndicatorStyle';
// import { Typography } from '@material-ui/core';
//
// const LoadingIndicator = (props) => {
//     const classes = useStyles();
//     const { typographyVariant, typographyText } = props;
//     return(
//         <div className={classes.root}>
//             <CircularProgress />
//             <Typography variant={typographyVariant}>{typographyText}</Typography>
//         </div>
//     )
// }
//
// export default LoadingIndicator;

import React from "react";
import clsx from "clsx";
import "@/css/redirecting.css";

const LoadingIndicator = ({ centered, className, style }) => {
  return (
    <div
      className={clsx("loading-wrapper", centered && "centered", className)}
      style={style}
    >
      <div className="loadingio-spinner-ellipsis-0e9htm6lpb7">
        <div className="ldio-tk8dyrglbc">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingIndicator;
